import { ISetting } from '@/interfaces/setting';
import dayjs from 'dayjs';
import React from 'react';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { DetailItem } from '@/components/dataItem/data-view-item';
dayjs.extend(buddhistEra);
interface IProps {
  setting: ISetting;
  date: Date;
  currentPage: number;
  pageCount: number;
}

const TemplateTaxInvoiceHeader = ({
  setting,
  date,
  currentPage,
  pageCount,
}: IProps) => {
  return (
    <>
      <div className="flex flex-col gap-1 items-center pt-5 pb-3">
        <div className="text-lg font-bold">รายงานภาษีขาย</div>
      </div>
      <div className="absolute top-5 right-5 ...">
        <div className="text-xs">{`หน้า ${currentPage}/${pageCount}`}</div>
      </div>
      <div className="flex flex-row gap-20 justify-center w-ful mb-3">
        <DetailItem
          detail={`${dayjs(date).format('MMMM')}`}
          label="เดือนภาษี"
          customLabelClass="text-black font-normal text-sm md:min-w-[80px]"
          customClass="text-black font-normal text-sm"
        />
        <DetailItem
          detail={`${dayjs(date).format('BBBB')}`}
          label="ปี"
          customLabelClass="text-black font-normal text-sm md:min-w-[50px]"
          customClass="text-black font-normal text-sm"
        />
      </div>
      <div className="flex flex-row gap-2">
        <DetailItem
          detail={'บริษัท อัลไลด์ อโกร จำกัด'}
          label="ชื่อผู้ประกอบการ"
          customLabelClass="text-black font-normal text-sm md:min-w-[120px]"
          customClass="text-black font-normal text-sm md:w-[350px]"
        />
        <DetailItem
          detail={`${setting?.companyTaxId}`}
          label="เลขประจำตัวผู้เสียภาษี"
          customLabelClass="text-black font-normal text-sm md:min-w-[50px]"
          customClass="text-black font-normal text-sm"
        />
        {/* <div className="text-sm">{`ชื่อผู้ประกอบการ ${setting?.companyName}`}</div>
        <div className="flex flex-row justify-between">
          <div className="text-sm">{`เลขประจำตัวผู้เสียภาษี ${setting?.companyTaxId}`}</div>
          <div className="text-sm">{`สำนักงานใหญ่`}</div>
          <div className="text-sm">{`หน้า ${currentPage}/${pageCount}`}</div>
        </div>
        <div className="text-sm">{setting?.companyAddress}</div> */}
      </div>
      <div className="flex flex-row gap-2 mt-2 pb-2">
        <DetailItem
          detail={'บริษัท อัลไลด์ อโกร จำกัด'}
          label="ชื่อสถานประกอบการ"
          customLabelClass="text-black font-normal text-sm md:min-w-[120px]"
          customClass="text-black font-normal text-sm md:w-[350px]"
        />
        <DetailItem
          detail={``}
          label={'สำนักงานใหญ่'}
          customLabelClass="text-black font-normal text-sm md:min-w-[50px]"
          customClass="text-black font-normal text-sm"
        />
      </div>
    </>
  );
};

export default TemplateTaxInvoiceHeader;
